import classNames from 'classnames'
import React from 'react'
import { AdminManagePartisanChartState } from '../../hooks/use-admin-manage-partisan-chart'

const AdminManagePartisanChartGeneralData: React.FC<{
  state: AdminManagePartisanChartState
  candidatesNamesChecked: boolean
  setCandidatesNamesChecked: (e: any) => void
}> = ({
  state: {
    form: { register, formState, watch, getValues, setValue },
    states,
  },
  candidatesNamesChecked,
  setCandidatesNamesChecked,
}) => {
  const state = watch('state')
  const showNamesWatch = watch('showCandidateNames')
  const preferredPartyWatch = watch('createPreferredParty')

  const resetRace = () => {
    if (getValues()?.races) {
      const resetedRaces = getValues().races.map((race) => {
        const resetedRace = {
          ...race,
          candidateNames: [],
          candidates: 0,
          parties: race?.parties.map((party) => {
            return {
              ...party,
              candidateNames: [],
              candidates: 0,
            }
          }),
        }
        return resetedRace
      })

      setValue('races', resetedRaces)
    }
  }

  const toggleCandidateNames = () => {
    setValue('showCandidateNames', !showNamesWatch)
    resetRace()
  }

  const togglePreferredParty = () => {
    setValue('createPreferredParty', !preferredPartyWatch)
    resetRace()
  }

  return (
    <div className="grid grid-cols-2 gap-x-[80px] gap-y-8 mt-16">
      <div>
        <label
          htmlFor="municipality"
          className="font-medium tracking-widest uppercase"
        >
          Municipality name
        </label>
        <input
          {...register('municipality')}
          type="text"
          id="municipality"
          placeholder="Municipality Name"
          className={classNames(
            'w-full mt-2 px-4 py-3 border rounded-md border-primary-blue',
            {
              'border-red-500 focus:outline-red-500':
                formState?.errors?.municipality,
            }
          )}
        />
        {formState?.errors?.municipality && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.municipality.message}
          </div>
        )}
      </div>
      <div>
        <label
          htmlFor="county"
          className="font-medium tracking-widest uppercase"
        >
          County
        </label>
        <input
          {...register('county')}
          type="text"
          id="county"
          placeholder="County"
          className={classNames(
            'w-full mt-2 px-4 py-3 border rounded-md border-primary-blue',
            {
              'border-red-500 focus:outline-red-500': formState?.errors?.county,
            }
          )}
        />
        {formState?.errors?.county && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.county.message}
          </div>
        )}
      </div>
      <div>
        <label
          htmlFor="state"
          className="font-medium tracking-widest uppercase"
        >
          State
        </label>
        <select
          {...register('state')}
          id="state"
          disabled={states.length === 0}
          className={classNames(
            'px-[15px] mt-2 py-3 w-full border rounded-md border-primary-blue hover:cursor-pointer',
            {
              'border-red-500 focus:outline-red-500': formState?.errors?.state,
            }
          )}
        >
          <option value="" disabled selected>
            Select State
          </option>
          {states.map((state) => (
            <option key={`state-${state.id}`} value={state.id}>
              {state.name}
            </option>
          ))}
        </select>
        {formState?.errors?.state && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.state.message}
          </div>
        )}
      </div>
      <div>
        <label
          htmlFor="precinct"
          className="font-medium tracking-widest uppercase"
        >
          Precinct Number
        </label>
        <input
          {...register('precinct')}
          type="text"
          placeholder="Precinct Number"
          className={classNames(
            'w-full mt-2 px-4 py-3 border rounded-md border-primary-blue',
            {
              'border-red-500 focus:outline-red-500':
                formState?.errors?.precinct,
            }
          )}
        />
        {formState?.errors?.precinct && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.precinct.message}
          </div>
        )}
      </div>
      <div>
        <label
          htmlFor="electionDate"
          className="font-medium tracking-widest uppercase"
        >
          Date of election
        </label>
        <input
          {...register('electionDate')}
          type="date"
          id="electionDate"
          placeholder="Select Date"
          className={classNames(
            'w-full mt-2 px-4 py-3 border rounded-md border-primary-blue',
            {
              'border-red-500 focus:outline-red-500':
                formState?.errors?.electionDate,
            }
          )}
        />
        {formState?.errors?.electionDate && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.electionDate.message}
          </div>
        )}
      </div>
      <div className="flex justify-between">
        <label className="flex justify-center mt-12">
          <input
            type="checkbox"
            className="w-6 h-6 p-2 mr-2 border border-primary-blue"
            checked={getValues().showCandidateNames}
            onChange={toggleCandidateNames}
          />
          <span className="h-6">Add Names for Candidates</span>
        </label>
        <label className="flex justify-center mt-12">
          <input
            {...register('createPreferredParty')}
            type="checkbox"
            className="w-6 h-6 p-2 mr-2 border border-primary-blue"
            checked={preferredPartyWatch}
            onChange={togglePreferredParty}
          />
          <span className="h-6">Add Preferred Party</span>
        </label>
      </div>
    </div>
  )
}

export default AdminManagePartisanChartGeneralData
